import * as React from 'react';
import { ShippingCustomer } from '../../../../api/types/shipping-customer';
import { TextField } from '../../../../components/TextField/TextField';
import { extractNumber, formatMonthDayYear, formatPhoneNumber } from '../../utils/input-formatters';
import { isValidEmail, isValidPhone } from '../../utils/validation-rules';

interface ICustomerFormProps {
    customer?: {
        name: string;
        phone: string;
        email: string;
        vehicleYear?: string;
        vehicleMake?: string;
        vehicleModel?: string;
        dropOffDate?: string;
    };
    handleSubmitCustomerInfo?: (customer: ShippingCustomer) => void;
}

class CustomerForm extends React.Component<ICustomerFormProps> {
    constructor(props: ICustomerFormProps) {
        super(props);

        this.validateForm = this.validateForm.bind(this);
        this.handleUpdateField = this.handleUpdateField.bind(this);
    }
    public state = {
        customer: this.props.customer ? this.props.customer : {},
        name: '',
        phone: '',
        email: '',
        year: '',
        make: '',
        model: '',
        dropDate: '',
        submitReady: false,
        nameError: '',
        phoneError: '',
        emailError: '',
        validForm: true,
    };
    public static defaultProps = {
        customer: null,
    };
    private handleUpdateField(value: string, event: any, mask?: string) {
        switch (event.target.name) {
            case 'phone':
                this.setState(
                    {
                        [event.target.name]: formatPhoneNumber(value),
                    },
                    this.checkSubmitReady
                );
                break;
            case 'dropDate':
                this.setState(
                    {
                        [event.target.name]: formatMonthDayYear(value),
                    },
                    this.checkSubmitReady
                );
                break;
            case 'year':
                const currentYearValue = value === '' ? value : extractNumber(value).toString();
                this.setState(
                    {
                        [event.target.name]:
                            currentYearValue !== '0' && currentYearValue.length < 5
                                ? currentYearValue
                                : this.state.year,
                    },
                    this.checkSubmitReady
                );
                break;
            default:
                this.setState(
                    {
                        [event.target.name]: value,
                    },
                    this.checkSubmitReady
                );
        }
    }
    private checkSubmitReady() {
        if (
            this.state.name &&
            this.state.name.length !== 0 &&
            this.state.phone &&
            this.state.phone.length !== 0 &&
            this.state.email &&
            this.state.email.length !== 0
        ) {
            this.setState({ submitReady: true });
        } else {
            this.setState({ submitReady: false });
        }
    }
    private validateForm() {
        const msgs: any = {
            validForm: true,
            nameError: '',
            phoneError: '',
            emailError: '',
        };
        const customerData: ShippingCustomer = {
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email,
            vehicleYear: this.state.year,
            vehicleMake: this.state.make,
            vehicleModel: this.state.model,
            dropOffDate: this.state.dropDate,
        };

        if (this.state.name === '') {
            (msgs.nameError = 'This field is required'), (msgs.validForm = false);
        }

        if (this.state.phone === '') {
            (msgs.phoneError = 'This field is required'), (msgs.validForm = false);
        } else if (isValidPhone(this.state.phone) === false) {
            msgs.phoneError = 'You must supply a valid 10-digit Phone number';
            msgs.validForm = false;
        }

        if (this.state.email === '') {
            (msgs.emailError = 'This field is required'), (msgs.validForm = false);
        } else if (isValidEmail(this.state.email) === false) {
            msgs.emailError = 'You must supply a valid Email Address';
            msgs.validForm = false;
        }

        for (const key of Object.keys(msgs)) {
            this.setState({ [key]: msgs[key] });
        }

        if (this.props.handleSubmitCustomerInfo && msgs.validForm) {
            this.scrollTo('#laas-route-calculator');
            this.props.handleSubmitCustomerInfo(customerData);
        } else {
            this.scrollTo('#laas-customer-form');
        }
    }
    private scrollTo(anchor: string) {
        const elementToBeViewed = document.querySelector(anchor);
        if (elementToBeViewed) {
            elementToBeViewed.scrollIntoView();
        }
    }
    public render() {
        return (
            <section id="laas-customer-form" className="laas-customer-form">
                <h2 className="laas-customer-form-header">Great, we've got your route! Just a few more details</h2>
                <div className="laas-customer-form-container">
                    <div className="laas-customer-section">
                        <div className="laas-form-section-head">Your information</div>
                        <TextField
                            id="name-field"
                            label="Name"
                            name="name"
                            onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                            value={this.state.name}
                            helperText={this.state.nameError}
                        />
                        <div className="laas-form-personal-info">
                            <TextField
                                id="phone-field"
                                className="text-field-half"
                                label="Phone"
                                name="phone"
                                type="tel"
                                onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                                value={this.state.phone}
                                helperText={this.state.phoneError}
                            />
                            <TextField
                                id="email-field"
                                className="text-field-half"
                                label="Email Address"
                                name="email"
                                onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                                value={this.state.email}
                                helperText={this.state.emailError}
                            />
                        </div>
                    </div>
                    <div className="laas-form-customer-section">
                        <div className="laas-form-section-head">Your vehicle</div>
                        <div className="laas-form-vehicle">
                            <TextField
                                id="year-field"
                                className="text-field-third"
                                label="Year"
                                name="year"
                                onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                                value={this.state.year}
                            />
                            <TextField
                                id="make-field"
                                className="text-field-third"
                                label="Make"
                                name="make"
                                onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                                value={this.state.make}
                            />
                            <TextField
                                id="model-field"
                                className="text-field-third"
                                label="Model"
                                name="model"
                                onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                                value={this.state.model}
                            />
                        </div>
                    </div>
                    <div className="laas-form-customer-section laas-form-drop-off">
                        <div className="laas-form-section-head">When do you want to drop off your vehicle?</div>
                        <p className="laas-form-section-sub">
                            We're estimating shipping will take 2-21 days, depending on route.
                        </p>
                        <TextField
                            id="desired-drop-off-date-field"
                            label="Desired drop-off-date"
                            name="dropDate"
                            onChange={(event: any) => this.handleUpdateField(event.target.value, event)}
                            inputProps={{ placeholder: 'MM/DD/YYYY' }}
                            value={this.state.dropDate}
                        />
                    </div>
                    <button
                        id="laas-customer-form-submit"
                        className="laas-customer-form-submit"
                        onClick={this.validateForm}
                        disabled={!this.state.submitReady}
                    >
                        submit
                    </button>
                </div>
            </section>
        );
    }
}

export default CustomerForm;
